import { clear, el } from '../utils/dom.js';

/**
 * Render route deviation summary.
 */
export function renderRouteDeviation(container, deviation) {
  clear(container);
  if (!deviation) return;

  const root = el('div', { class: 'route-deviation-summary' });
  root.appendChild(el('h4', { text: 'Route Deviation: Recorded vs Course' }));

  const grid = el('div', { class: 'summary-stats' });

  const items = [
    {
      label: 'Course Distance',
      value: `${(deviation.courseDistance / 1000).toFixed(2)} km`
    },
    {
      label: 'Recorded Distance',
      value: `${(deviation.actualDistance / 1000).toFixed(2)} km`
    },
    {
      label: 'Distance Delta',
      value: `${deviation.distanceDelta >= 0 ? '+' : ''}${(deviation.distanceDelta / 1000).toFixed(2)} km (${deviation.distanceDeltaPct >= 0 ? '+' : ''}${deviation.distanceDeltaPct.toFixed(1)}%)`
    },
    {
      label: 'Elev. Gain (Course)',
      value: `${Math.round(deviation.courseElevGain)} m`
    },
    {
      label: 'Elev. Gain (Recorded)',
      value: `${Math.round(deviation.actualElevGain)} m`
    },
    {
      label: 'Elev. Gain Delta',
      value: `${deviation.elevGainDelta >= 0 ? '+' : ''}${Math.round(deviation.elevGainDelta)} m`
    },
    {
      label: 'Avg. Lateral Deviation',
      value: `${Math.round(deviation.avgDeviationMeters)} m`
    },
    {
      label: 'Course Sections',
      value: String(deviation.sectionComparison.courseSectionCount)
    },
    {
      label: 'Recorded Sections',
      value: String(deviation.sectionComparison.actualSectionCount)
    }
  ];

  for (const item of items) {
    grid.appendChild(
      el('div', { class: 'stat-item' }, [
        el('div', { class: 'stat-value', text: item.value }),
        el('div', { class: 'stat-label', text: item.label })
      ])
    );
  }

  root.appendChild(grid);
  container.appendChild(root);
}
